import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
 
@Injectable()
export class MessageService {
    private subject = new Subject<any>();
    private scrollToContact = new Subject<any>();
    private scrollToReviews = new Subject<any>();
 
    sendMessage(message: string) {
        this.subject.next({ text: message });
    }

    sendScrollToContact(message: string) {
        this.scrollToContact.next({ text: message });
    }

    sendScrollToReviews(message: string) {
        this.scrollToReviews.next({ text: message });
    }
 
    clearMessage() {
        this.subject.next();
    }
 
    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    getScrollToContact(): Observable<any> {
        return this.scrollToContact.asObservable();
    }

    getScrollToReviews(): Observable<any> {
        return this.scrollToReviews.asObservable();
    }
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/message.service.ts